(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-filter-template"]) return;
  try {
    

$('#tags_one :checkbox').change(function() {
    // this will contain a reference to the checkbox   
    if (this.checked) {
        // the checkbox is now checked 
                console.log($(this).val() + ' is now checked');

    } else {
        // the checkbox is now no longer checked
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var topbarLinks = document.querySelectorAll('.topbar__content a');
  if (topbarLinks.length > 0) {
    topbarLinks.forEach(function(link) {
      link.setAttribute("tabindex", "-1");
    });
  }
});

  } catch(e) { console.error(e); }
})();
      })();
